import { AutoPricingResultType } from 'src/WebApiController';

export const ACTIONABLE_RESULT_TYPES = new Set([
  AutoPricingResultType.PriceHitMaxAllowedDrop,
]);

export const hasActionSupport = (
  resultType?: AutoPricingResultType
): boolean => {
  return resultType ? ACTIONABLE_RESULT_TYPES.has(resultType) : false;
};
